<template>
  <v-row align="center" justify="center" class="mt-0">
    <v-col cols="auto" class="my-auto caption"><strong>WIN PROBABILITY</strong> </v-col>
    <v-col cols="auto" class="my-auto">
      <v-img
        v-if="logoExists"
        class="mx-auto d-print-none"
        aspect-ratio="1"
        max-width="45"
        height="30"
        style="min-width:30px"
        contain
        :src="logoSource"
      />
    </v-col>
    <v-col cols="auto" class="my-auto text-h6">
        <strong>{{ winProb }}</strong>
    </v-col>
  </v-row>
</template>
<script>
export default {
  name: "WinProbability",
  props: {
    event: Object,
  },
  computed: {
    winProbAway() {
        return  Math.round(this.event.WinProbAway * 100);
    },
    winProbHome() {
        return  Math.round(this.event.WinProbHome * 100);
    },
    winProb() {
      if (this.winProbAway > this.winProbHome) {
        return this.winProbAway + "%";
      }
      if (this.winProbAway < this.winProbHome) {
        return this.winProbHome + "%";
      }
      return "50/50";
    },
    logoSource() {
      if (this.winProbAway > this.winProbHome) {
        var logo = this.event.AwayTeamMasterTeamID
          ? this.event.AwayTeamMasterTeamID
          : this.event.AwayTeamID;
        return "/images/TeamLogo/SVG/" + logo + ".svg";
      }
      if (this.winProbAway < this.winProbHome) {
        var logo = this.event.HomeTeamMasterTeamID
          ? this.event.HomeTeamMasterTeamID
          : this.event.HomeTeamID;
        return "/images/TeamLogo/SVG/" + logo + ".svg";
      }
      return null;
    },
    logoExists() {
      if (this.winProbAway > this.winProbHome) {
        return this.event.AwayTeamLogoExists;
      }
      if (this.winProbAway < this.winProbHome) {
        return this.event.HomeTeamLogoExists;
      }
      return false;
    },
  },
};
</script>